import type { QueryClient } from "@tanstack/react-query";
import { CustomerVaultsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";
import { normalizeVaultDefaults } from "@/features/balance/utils/vault";
import type { GetCustomerVaultResponse } from "@/openapi/generated/models";

export async function prefetchVaultsGet(
  userId: number,
  tenantId: number,
  queryClient: QueryClient,
  accessToken?: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching vaults");
  }

  const service = createAuthenticatedApi(CustomerVaultsApi, accessToken);

  await queryClient.prefetchQuery<GetCustomerVaultResponse[]>({
    queryKey: [QueryKeys.CustomerVaults, userId],
    queryFn: async () => {
      const result = await service.apiUsersUserIdVaultsGet({
        userId,
        xTenantID: tenantId,
      });

      return normalizeVaultDefaults(result ?? []);
    },
    staleTime: 2 * 60 * 1000,
  });

  return queryClient;
}
